import { render, staticRenderFns } from "./salesCard.vue?vue&type=template&id=48cc52e4&scoped=true&"
import script from "./salesCard.vue?vue&type=script&lang=js&"
export * from "./salesCard.vue?vue&type=script&lang=js&"
import style0 from "./salesCard.vue?vue&type=style&index=0&id=48cc52e4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48cc52e4",
  null
  
)

export default component.exports